import React, { useState, useEffect, useRef } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import Chatbot from 'react-chatbot-kit';
import config from '../chatbot/config.js';
import MessageParser from '../chatbot/MessageParser.js';
import ActionProvider from '../chatbot/ActionProvider.js';
import { v4 as uuidv4 } from 'uuid';
// import CustomInput from '../components/chatbot/CustomInput.js';
// import LoadingSpinner from '../components/chatbot/LoadingSpinner.js';
import 'react-chatbot-kit/build/main.css';
import '../css/chatbot.css';
// import ChatCustomLoader from '../components/chatbot/ChatCustomLoader.js';

const ChatBot = (props) => {
  const [showPopup, setShowPopup] = useState(false);
  const { loginId, chatbot, pkg, setChatbot } = props;
  let prevMessage;
  let sessionKey = uuidv4();

  // const [messages, setMessages] = useState(() => {
  //   console.log('load message');
  //   const savedMessages = JSON.parse(localStorage.getItem('chat_messages'));
  //   return savedMessages;
  //   // return savedMessages ? JSON.parse(savedMessages) : [];
  // });

  const saveMessages = (message, HTMLString) => {
    console.log('saveMessage');
    localStorage.setItem('chat_messages', JSON.stringify(message));
  };
  const loadMessages = () => {
    console.log('loadMessage');
    // console.log(localStorage.getItem('chat_messages'));
    if (localStorage.getItem('chat_messages')) {
      let messages = localStorage.getItem('chat_messages');

      if (messages === 'undefined') {
      } else {
        messages = JSON.parse(messages);
        console.log(prevMessage);
        return messages;
      }
    }
  };

  useEffect(() => {
    console.log('chatbot_init');
    let prevMessage;
    if (localStorage.getItem('chat_prev')) {
      prevMessage = JSON.parse(localStorage.getItem('chat_prev'));
    }

    if (chatbot) {
      const box = document.querySelector('body');
      const hbox = box.offsetHeight;

      if (prevMessage === '채팅으로 문의하기') {
        document.getElementsByClassName(
          'react-chatbot-kit-chat-input-container'
        )[0].style.display = '';
        if (hbox <= 667) {
          document.getElementsByClassName(
            'react-chatbot-kit-chat-message-container'
          )[0].style.height = hbox - 200 + 'px';
        } else {
          document.getElementsByClassName(
            'react-chatbot-kit-chat-message-container'
          )[0].style.height = '540px';
        }
      } else {
        document.getElementsByClassName(
          'react-chatbot-kit-chat-input-container'
        )[0].style.display = 'none';
        if (hbox <= 667) {
          document.getElementsByClassName(
            'react-chatbot-kit-chat-message-container'
          )[0].style.height = hbox - 140 + 'px';
        } else {
          document.getElementsByClassName(
            'react-chatbot-kit-chat-message-container'
          )[0].style.height = '610px';
        }
      }
    }
  }, [chatbot]);

  // useEffect(() => {
  //   console.log('save message');
  //   console.log(messages);
  //   localStorage.setItem('chat_messages', JSON.stringify(messages));
  // }, [messages]);

  const _setChatbot = () => {
    console.log(chatbot);
    if (chatbot) {
      if (localStorage.getItem('chat_messages')) {
        setShowPopup(true);
      } else {
        setChatbot(!chatbot);
      }

      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ show: false }));
      }
    } else {
      setChatbot(!chatbot);
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ show: true }));
      }
    }
  };
  const _chatbotDel = () => {
    setShowPopup(false);
    setChatbot(!chatbot);
    setTimeout(() => {
      localStorage.removeItem('chat_messages');
      localStorage.removeItem('chat_prev');
    }, 500);
  };
  const _chatbotSave = () => {
    setShowPopup(false);
    setChatbot(!chatbot);
  };
  const _ing = () => {
    setShowPopup(false);
  };
  const _config = () => {
    let prevMessage;
    if (localStorage.getItem('chat_prev')) {
      prevMessage = JSON.parse(localStorage.getItem('chat_prev'));
    }

    const cf = {
      ...config,
      state: {
        sessionKey: sessionKey,
        id: loginId,
        pkg: pkg,
        prevMessage: prevMessage,
      },
    };
    return cf;
  };
  return (
    <>
      <div className="chatbot-main-container">
        {chatbot ? (
          <Chatbot
            config={_config()}
            messageParser={MessageParser}
            actionProvider={ActionProvider}
            placeholderText="궁금한 내용을 입력하세요."
            headerText={'ANIPLUS CHATBOT'}
            messageHistory={loadMessages()}
            saveMessages={saveMessages}
            // validator
            // runInitialMessagesWithHistory={false}
          />
        ) : null}
      </div>
      <div className="chatbot-icon" onClick={_setChatbot}>
        {chatbot ? (
          <img src="/img/icon_chatbot_colose.png" />
        ) : (
          <img src="/img/icon_chatbot.png" />
        )}
      </div>

      {showPopup && (
        <div className="chatbot-popup">
          <div className="chatbot-popup-title">
            <h2>문의 종료</h2>
          </div>
          <div className="chatbot-popup-content">
            <p>진행중인 문의 내용이 존재합니다.</p>
            <p>대화 내용을 저장 하시겠습니까?</p>
          </div>

          <div className="chatbot-popup-btn">
            <div className="chatbot-popup-btn-save" onClick={_chatbotSave}>
              저장후 닫기
            </div>
            <div className="chatbot-popup-btn-end" onClick={_chatbotDel}>
              삭제후 닫기
            </div>
            <div className="chatbot-popup-btn-ing" onClick={_ing}>
              취소
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default shopContext(withRouter(ChatBot));
